<template>
  <li v-for="choice of optionsData" :key="choice.label" class="summary-choice">
    <img
      :src="getImage(choice.icon)"
      width="32"
      height="32"
      alt=""
      class="summary-choice__icon"
    />
    <p class="summary-choice__label">{{ choice.label }}</p>
  </li>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { getImage, QuestionnaireView } from '@/models/onboarding'
import type { GenreSelectionPage, OptionsPage } from '@/models/onboarding.types'

import { assertNotNull } from '@/helpers/typing'

const props = defineProps<{
  view: QuestionnaireView
  pageID: 'what-prevents-you' | 'genre-selection'
  userChoices: string[]
}>()

const optionsData = computed(() => {
  const pageData = props.view.getPage(props.pageID) as
    | OptionsPage
    | GenreSelectionPage

  const options = pageData.options

  return props.userChoices.map((choice) => {
    const optionData = options.find(
      // @ts-expect-error - Options in the OptionsPage don't have IDs,
      // so we use the label as a fallback.
      (option) => (option.id ?? option.label) === choice,
    )

    const icon = assertNotNull(optionData?.icon)
    const label = assertNotNull(optionData?.label)

    return {
      label,
      icon,
    }
  })
})
</script>

<style lang="scss" scoped>
.summary-choice {
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
  padding: 16px;
  border-radius: 14px;
  border: 1px solid $c-border-2;
  background: $c-white;

  &__label {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.02em;
    color: $c-black-2;
  }
}
</style>
